<script setup lang="ts">
import { FileAttachment } from "@/bapi-client/types/common/attachment";
import { computed } from "vue";

interface Props {
  file: FileAttachment;
}

const props = defineProps<Props>();

const icons: Record<string, string> = {
  csv: "file-arrow-down",
  xls: "file-arrow-down",
  xlsx: "file-arrow-down",
  pdf: "file-arrow-down",
  txt: "file-arrow-down",
  rtf: "file-arrow-down",
  doc: "file-arrow-down",
  docx: "file-arrow-down",
  mov: "magnifying-glass-play",
  mpv: "magnifying-glass-play",
  mp4: "magnifying-glass-play",
};

const icon = computed(() => icons[props.file.extension] ?? "file");
</script>

<template>
  <span
    class="hover:ring-primary flex items-center gap-2 rounded-md border bg-white px-2 py-2 align-middle text-sm transition hover:bg-white hover:shadow-md hover:ring"
  >
    <i class="fa-light fa-2x ml-2" :class="['fa-' + icon]"></i>
    <span class="flex items-center border-l-2 border-l-gray-400 pl-2 font-medium whitespace-nowrap">
      {{ file.fileName }}
    </span>
  </span>
</template>
